// Heat source/sink vertex schema
// Thermal device. Dual elevation.

import { z } from 'zod';
import { BaseVertexSchema } from '../base/vertex';
import { ValueWithUnitSchema, PressureDropCurveSchema } from '../base/common';
import { ThermalCalculationSchema } from '../base/thermal';

export const HeatSourceSinkVertexSchema = BaseVertexSchema.extend({
  type: z.literal('heat_source_sink'),
  // C++ emits dual elevations only when is_set() (per as_json audit § 4).
  inlet_elevation: ValueWithUnitSchema.optional(),
  outlet_elevation: ValueWithUnitSchema.optional(),
  pressure_drop_curve: PressureDropCurveSchema,
  /** ID of linked device for flow-controlled thermal calculation */
  linked_device_id: z.string().optional(),
  thermal_calculation: ThermalCalculationSchema,
  temperature_tolerance: ValueWithUnitSchema.optional(),
});

export type HeatSourceSinkVertex = z.infer<typeof HeatSourceSinkVertexSchema>;
